import type { ReactNode } from 'react';

import { cn } from '@mint-lib/tw-utils';
import { Command as CommandPrimitive } from 'cmdk';
import { Dialog as DialogPrimitive } from 'radix-ui';

export default function CommandDialog({
  title,
  'aria-describedby': ariaDescribedBy,
  open,
  defaultOpen,
  onOpenChange,
  modal,
  container,
  footerContent,
  className,
  overlayClassName,
  contentClassName,
  ...props
}: React.ComponentProps<typeof CommandPrimitive.Dialog> & {
  title: string;
  footerContent: ReactNode;
}) {
  return (
    <DialogPrimitive.Root
      data-slot="command-dialog-content"
      open={open}
      defaultOpen={defaultOpen}
      onOpenChange={onOpenChange}
      modal={modal}
    >
      <DialogPrimitive.Portal container={container}>
        <DialogPrimitive.Overlay
          className={cn(
            'fixed inset-0 z-overlay bg-ui-overlay data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:animate-in data-[state=open]:fade-in-0',
            overlayClassName,
          )}
        />
        <DialogPrimitive.Content
          data-slot="command-dialog-content"
          aria-describedby={ariaDescribedBy}
          className={cn(
            'fixed top-[36%] left-[50%] z-dialog flex h-135.75 w-160 translate-x-[-50%] translate-y-[-50%] flex-col rounded-[3px] bg-ui-primary shadow-lg duration-200 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95',
            contentClassName,
          )}
        >
          <DialogPrimitive.Title className="sr-only">
            {title}
          </DialogPrimitive.Title>
          {props.children}
          <div
            data-slot="command-footer"
            className={cn(
              'flex h-10 items-center rounded-b-[3px] border border-border-secondary bg-background-default p-2',
            )}
          >
            {footerContent}
          </div>
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  );
}
